import { getJwtFromCookie } from '@repo/constants';
import type { IbxPayload } from './types';

const _jwtDecodeModule = import('jwt-decode');

export function resolveToken(): string | null {
  return getJwtFromCookie();
}

export async function decodeToken(token: string): Promise<IbxPayload> {
  const { jwtDecode } = await _jwtDecodeModule;
  return jwtDecode<IbxPayload>(token);
}
